// extracted by mini-css-extract-plugin
module.exports = {"input":"checkbox_input__3DG6x","container":"checkbox_container__38MRM","checkbox":"checkbox_checkbox__2r6oW","disabled":"checkbox_disabled__1oW31"};